import colors from './Colors'

const fonts = {
  size: {
    body: '14px',
    smaller: '12px',
    heading4: '17px',
  },
  family: {
    body: "'Roboto', sans-serif",
    lato: 'Lato, Helvetica, sans-serif',
  },
  weight: {
    bold: 800,
    medium: 'normal',
    light: 200,
  },
  color: {
    body: colors.gray_darkest,
  },
}

export default fonts
